var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"other_wrap"},[_c('el-page-header',{on:{"back":_vm.$core.goBack}}),_c('img',{attrs:{"src":require("../../assets/img/other.png"),"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }